import React from "react";

function statusBadge(status) {
    if (!status) return null;
    const isLive = status.elapsed != null && status.long !== "Match Finished";
    if (isLive) {
        return (
            <span className="inline-flex items-center gap-1 font-mono text-[10px] uppercase tracking-widest text-red-400">
                <span className="inline-block w-1.5 h-1.5 rounded-full bg-red-500 live-dot" />
                LIVE · {status.elapsed}'
            </span>
        );
    }
    return (
        <span className="font-mono text-[10px] uppercase tracking-widest text-zinc-500">
            {status.long || status.short || "—"}
        </span>
    );
}

export default function MatchCard({ match, onClick, testIdPrefix = "match" }) {
    return (
        <button
            type="button"
            onClick={onClick}
            className="text-left w-full bg-card border border-border p-5 hover:border-primary/60 hover:-translate-y-0.5 transition-snappy"
            data-testid={`${testIdPrefix}-${match.id}`}
        >
            <div className="flex items-center justify-between mb-3">
                {statusBadge(match.status)}
                <span className="font-mono text-[10px] uppercase tracking-widest text-zinc-500 truncate ml-2">
                    {match.country ? `${match.country}` : ""}
                </span>
            </div>
            <div className="space-y-1">
                <div className="flex items-center justify-between gap-3">
                    <span className="font-bold text-white truncate">{match.home}</span>
                    <span className="font-mono text-xl font-bold text-primary">
                        {match.goals?.home ?? "—"}
                    </span>
                </div>
                <div className="flex items-center justify-between gap-3">
                    <span className="font-bold text-white truncate">{match.away}</span>
                    <span className="font-mono text-xl font-bold text-primary">
                        {match.goals?.away ?? "—"}
                    </span>
                </div>
            </div>
            <div className="font-mono text-[10px] uppercase tracking-widest text-zinc-500 mt-3 truncate border-t border-border pt-2">
                {match.league}
            </div>
        </button>
    );
}
